import * as React from 'react';

import { compose, withProps } from 'recompose';

import type { TabOption } from 'bundles/enterprise-admin-drawers/components/components/TabbedFilterOptionList';
import type { FilterOption } from 'bundles/enterprise-admin-drawers/components/types';
import type {
  PropsFromWithUserFilterOptions,
  PropsToWithUserFilterOptions,
} from 'bundles/enterprise-admin-user-filters/components/SelectionDrawer';
import SelectionDrawer, {
  withUserFilterOptions,
} from 'bundles/enterprise-admin-user-filters/components/SelectionDrawer';

import _t from 'i18n!nls/enterprise-admin-user-filters';

type PropsFromCaller = {
  selectedContracts: FilterOption[];
  isOpen: boolean;
  defaultTab?: TabOption;
  onClose: () => void;
  onApply: (selectedContracts: FilterOption[]) => void;
} & Omit<PropsToWithUserFilterOptions, 'filterType'>;

type Props = PropsFromCaller & PropsFromWithUserFilterOptions;

export const ContractSelectionDrawer = ({
  isOpen,
  selectedContracts,
  filterOptions,
  loading,
  defaultTab,
  onClose,
  onApply,
  onRefetch,
}: Props) => {
  return (
    <SelectionDrawer
      heading={_t('Select contracts')}
      headingSupportText={_t('Choose the contracts to filter on')}
      searchLabel={_t('Search by contract')}
      helpMessage={_t('Select contracts to add to your filter')}
      filterType="CONTRACTS"
      isOpen={isOpen}
      selectedOptions={selectedContracts}
      availableOptions={filterOptions}
      loading={loading}
      defaultTab={defaultTab}
      onClose={onClose}
      onApply={onApply}
      onRefetch={onRefetch}
      data-testid="contract-selection-drawer"
    />
  );
};

export default compose<Props, PropsFromCaller>(
  withProps({
    filterType: 'CONTRACTS',
  }),
  withUserFilterOptions
)(ContractSelectionDrawer);
